// SidePanel.tsx
import React from "react";
import { Link } from "react-router-dom";
import { useUserContext } from "../../Contexts/UserContext";

const SidePanel: React.FC = () => {
    const {userData} = useUserContext();
    return (
        <div className="flex flex-col mt-10 border rounded-md shadow-lg bg-brown text-white p-4">
            <ul className="space-y-4">
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard">My Dashboard</Link>
                </li>
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/court-schedule">{userData.userRole === 'COUNSEL' ? 'Court Schedule' : 'Cause List'}</Link>
                </li>
                {userData.userRole === 'COUNSEL' && (
                    <>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/virtual-court-application">Apply for Virtual Court</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
							<Link to="/dashboard/represent-litigant">
								Represent a Litigant
							</Link>
						</li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/apply-for-ruling">Apply for Ruling</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/apply-for-judgement">Apply for Judgment</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/apply-for-records">Apply for Court Records</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to='/ongoing-sessions'>Ongoing Court Sessions</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/upcoming-cases">Upcoming Court Cases</Link>
                        </li>
                     </>
                )}
                {userData.userRole === 'JUDGE' && (
                    <>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/ruling-application">Applications for Ruling</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/Judgement-applications">Applications for Judgment</Link>
                        </li>
                        <li className="border-b-lightbrown border-b py-2">
                            <Link to="/dashboard/court-records-applications">Applications for Court Records</Link>
                        </li>
                     </>
                )}
                
               
                <li className="border-b-lightbrown border-b py-2">
                    <Link to="/dashboard/make-a-complaint">Make a Complaint</Link>
                </li>
            </ul>
            
        </div>
    );
};

export default SidePanel;
